import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box } from "@material-ui/core";

import "./CircularProgress.scss";

const useStylesFacebook = makeStyles((theme) => ({
  top: {
    color: "#278BA2"
  },
  circle: {
    strokeLinecap: "round"
  }
}));

export default function MyCircularProgressbar({
  timeCompleted,
  // verified,
  // verifiedComplete,
  step,
  isVerified,
  setIsVerified
}) {
  const classes = useStylesFacebook();

  const [progress, setProgress] = useState(0);
  // const [isVerified, setIsVerified] = useState(false);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    let startTime = Date.now();
    let animationFrameId;

    const updateProgress = () => {
      const currentTime = Date.now();
      const elapsedTime = currentTime - startTime;
      let newProgress = (elapsedTime / timeCompleted) * 100;

      // Làm tròn newProgress đến hai chữ số thập phân
      newProgress = newProgress.toFixed(0);

      if (newProgress >= 100) {
        cancelAnimationFrame(animationFrameId);

        setIsVerified(true);
        // ĐẶT LẠI TIẾN TRÌNH
        setProgress(0);

        // setTimeout(() => {
        //   step !== 2 && setIsVerified(false);
        // }, 1000000);
      } else {
        setProgress(newProgress);
        animationFrameId = requestAnimationFrame(updateProgress);
      }
    };

    animationFrameId = requestAnimationFrame(updateProgress);

    step === 5 && setIsVerified(true);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, timeCompleted]);

  return (
    <Box>
      <div className={`loader ${isVerified && "verified-box"}`}>
        <div className={`circle circle1 ${isVerified && "verified"}`}>
          {step === 1 ||
            (!isVerified && (
              <>
                <CircularProgress
                  variant="determinate"
                  value={progress ? parseInt(progress) : 0}
                  className={classes.top}
                  classes={
                    {
                      // circle: classes.circle
                    }
                  }
                  size={94}
                  thickness={6.5}
                />
                <Box
                  sx={{
                    position: "absolute"
                  }}
                >
                  <h5>{progress ? parseInt(progress) : 0}%</h5>
                  {/* {step === 0 ? (
                    <p>Verify Loan Request</p>
                  ) : step === 1 ? (
                    <p>
                      Analysing your
                      <br /> information
                    </p>
                  ) : step === 2 ? (
                    <p>Searching Lenders</p>
                  ) : (
                    ""
                  )} */}
                </Box>
              </>
            ))}
          {isVerified && (
            <h5
              style={{
                color: "#00647A",
                textAlign: "center",
                fontFamily: "Poppins",
                fontSize: isMobile ? "10px" : "14px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal",
                background: "#fff"
              }}
            >
              Redirect...
            </h5>
          )}
        </div>
        <>
          <div className="circle circle2"></div>
          <div className="circle circle3"></div>
          <div className="circle circle4"></div>
          <div className="circle circle5"></div>
        </>
      </div>
    </Box>
  );
}
